import React from 'react'

export default function IconsPaperPlaneOutline({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
        >
            <path
                d='M2.47618 2.03219C2.41622 2.00292 2.34883 1.99239 2.2828 2.00198C2.21677 2.01158 2.15517 2.04084 2.10602 2.08596C2.05686 2.13109 2.02245 2.18997 2.00726 2.25494C1.99206 2.31991 1.9968 2.38795 2.02085 2.45019L3.91618 7.53485C4.02796 7.83501 4.02796 8.16537 3.91618 8.46552L2.02151 13.5502C1.99759 13.6123 1.99291 13.6803 2.0081 13.7451C2.02328 13.81 2.05762 13.8688 2.10666 13.9138C2.15569 13.9589 2.21715 13.9882 2.28305 13.9979C2.34895 14.0076 2.41624 13.9972 2.47618 13.9682L14.4762 8.30152C14.5333 8.27452 14.5815 8.23187 14.6153 8.17852C14.6491 8.12518 14.667 8.06333 14.667 8.00019C14.667 7.93704 14.6491 7.8752 14.6153 7.82185C14.5815 7.7685 14.5333 7.72585 14.4762 7.69885L2.47618 2.03219Z'
                stroke={color}
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path d='M4 8H14.6667' stroke={color} strokeWidth='1.25' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    )
}
